import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Zap, Phone } from "lucide-react";

const LINKS = [
  { label: "Off-Road", href: "#off-road" },
  { label: "Road Legal", href: "#road-legal" },
  { label: "Accessories", href: "#accessories" },
  { label: "Deals", href: "#deals" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    window.__lenis?.scrollTo(href, { offset: -70 });
  };

  return (
    <motion.header
      data-testid="main-nav-header"
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
      className={`sticky top-0 z-50 border-b transition-colors duration-500 ${
        scrolled
          ? "border-border bg-forest-deep/90 backdrop-blur-xl"
          : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 lg:px-8">
        <a
          href="#top"
          data-testid="nav-brand-logo"
          onClick={(e) => go(e, "#top")}
          className="group flex items-center gap-2.5"
        >
          <span className="clip-corner-sm flex h-9 w-9 items-center justify-center bg-brass transition-colors group-hover:bg-brass-bright">
            <Zap className="h-5 w-5 text-white" strokeWidth={2.25} fill="currentColor" />
          </span>
          <span className="font-serif text-lg font-black uppercase leading-none tracking-wide text-bone">
            Off-Road Electric
            <span className="block font-mono text-[9px] font-medium tracking-[0.42em] text-cyanx">
              Bikes
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              onClick={(e) => go(e, l.href)}
              className="group relative font-mono text-[11px] font-medium tracking-[0.2em] text-sand uppercase transition-colors hover:text-bone"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-0.5 w-0 bg-brass transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <a
          href="tel:07522364950"
          data-testid="nav-phone-cta"
          className="clip-corner-sm flex items-center gap-2 bg-brass px-4 py-2.5 font-mono text-[11px] font-bold tracking-[0.12em] text-white uppercase transition-colors hover:bg-brass-bright"
        >
          <Phone className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">07522 364950</span>
          <span className="sm:hidden">Call</span>
        </a>
      </div>
    </motion.header>
  );
};
